import React, { lazy, Suspense } from "react";
import { isEmpty } from "lodash";

import Skeleton from "~/components/loaders/Skeleton";
import ErrorBoundary from "~/components/ErrorBoundary";

const JumpLinkNavigationBlock = lazy(
    () => import("~/blocks/JumpLinkNavigationBlock"),
);

const ProductCategoryJumpLinks = ({ data }) => {
    const { jumpLinks, jumpLinksNoMarginBottom } =
        data.wpProductCategory.categoryData;

    if (isEmpty(jumpLinks)) {
        return null;
    }

    return (
        <ErrorBoundary>
            <Suspense fallback={<Skeleton variant="block" />}>
                <JumpLinkNavigationBlock
                    links={jumpLinks}
                    noMarginBottom={jumpLinksNoMarginBottom}
                />
            </Suspense>
        </ErrorBoundary>
    );
};

export default ProductCategoryJumpLinks;
